<template>
  <div>
    <div v-for="(r, i) in row" :key="i">
      {{ r.rateData.rate.type ? `(${r.rateData.rate.type}) ` : '' }}
      <bridge8-popover
        v-if="r.rateData && r.rateData.rate && r.rateData.rate.origin"
        :header-prefix="r.rateData.rate.origin.name !== r.rateData.rate.destination.name ? 'Origin: ' : 'Place: '"
        trigger="click"
        :obj="r.rateData && r.rateData.rate && r.rateData.rate.origin"
        :text-callback="origin => origin.name"
      />
      <span v-if="r.rateData.rate.origin.name !== r.rateData.rate.destination.name"> - </span>
      <bridge8-popover
        v-if="r.rateData && r.rateData.rate && r.rateData.rate.origin && r.rateData.rate.destination && r.rateData.rate.origin.name !== r.rateData.rate.destination.name"
        header-prefix="Destination: "
        trigger="click"
        :obj="r.rateData && r.rateData.rate && r.rateData.rate.destination"
        :text-callback="destination => destination.name"
      />
      <span v-if="r.rateData && r.rateData.rate && (r.rateData.rate.airline || r.rateData.rate.agent)"> by </span>
      <bridge8-popover
        v-if="r.rateData && r.rateData.rate && r.rateData.rate.airline"
        header-prefix="Airline: "
        trigger="click"
        :obj="r.rateData && r.rateData.rate && r.rateData.rate.airline"
        :text-callback="airline => airline.code"
      />
        <span v-if="r.rateData && r.rateData.rate && r.rateData.rate.airline && r.rateData.rate.agent">/</span>
      <bridge8-popover
        v-if="r.rateData && r.rateData.rate && r.rateData.rate.agent"
        header-prefix="Agent: "
        trigger="click"
        :obj="r.rateData && r.rateData.rate && r.rateData.rate.agent"
      />
      <span v-if="r.root && r.rateData.rate && r.rateData.rate.cargoTypes && r.rateData.rate.cargoTypes.length > 0">
        ({{ r.root.rate.cargo_types.join(', ') }})
      </span>
      <br />
      <span class="price-display">
        <mdb-icon
          v-if="r.rateData.price && (r.rateData.price.amount === null)"
          icon="exclamation"
          class="text-warning"
        />
        {{ r.rateData.price && r.rateData.price.display }}
      </span>
      <hr v-if="i !== row.length - 1" />
    </div>
  </div>
</template>

<script>
import Bridge8Popover from './Bridge8Popover'
import { mdbIcon } from 'mdbvue'

export default {
  name: 'CalcRatesTableCellName',
  props: {
    row: {
      type: Array,
      required: true
    }
  },
  components: {
    Bridge8Popover,
    mdbIcon
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CalcRatesTableCellName.vue